module.exports = __webpack_public_path__ + "static/media/logo.984161e3.svg";